import React from 'react';
import PropTypes from 'prop-types';
import CircleLoader from 'common/components/elements/loader/circle';
import Icon from 'common/components/elements/icons';
import cx from 'classnames';
import {
   sortableContainer,
   sortableElement,
} from 'react-sortable-hoc';

import { arrayMoveImmutable } from 'array-move';
import './style.scss';
import {
   MediaButton,
   MediaDragHandle,
} from 'common/components/modules/media';

const SortableItem = sortableElement(({
   value,
   index,
   paths,
   description,
   deleteImg,
}) => {
   return (
      value.loading ? (
         <div
            className={ cx({
               'mb-4 card select-none': true,
               'every-second-card': index < paths.length - 1 && index % 2 === 0,
               'last-card': index === paths.length - 1,
            }) }
         >
            <div
               style={ { minWidth: '180px' } }
               className='h-full flex items-center justify-center bg-placeholder border border-divider rounded-lg'>
               <CircleLoader color='major-dark' />
            </div>
         </div>
      ) :  (
         <div
            className={ cx({
               'mb-4 card select-none': true,
               'every-second-card': index < paths.length - 1 && index % 2 === 0,
               'last-card': index === paths.length - 1,
            }) }
         >
            <div
               style={ { minWidth: '180px' } }
               className='h-full w-full relative'>
               <img src={ value.src } className='h-full w-full rounded-lg object-cover object-center' alt='avatar' />
               {
                  !!description && (
                     <div
                        className='absolute rounded-t-lg top-0 left-0 flex flex-col pl-2 pr-6 pt-2 z-15'
                     >
                        <h6 className='text-xl text-major-dark font-bold leading-tight mb-2 select-none threeLine'>{ description }</h6>
                     </div>
                  )
               }
               <div
                  className={ cx({
                     'absolute w-full flex items-center top-0 right-0 rounded-t-lg p-2': true,
                     'justify-between': paths?.length > 1,
                     'justify-end': paths?.length <= 1,
                  }) }
               >
                  {
                     paths?.length > 1 &&
                        <MediaDragHandle
                           text='Drag to reorder'
                        />
                  }

                  <MediaButton
                     iconName='cancel'
                     onClick={ () => deleteImg(value.id) }
                     dataToolTipContent='Delete'
                  />
               </div>
            </div>
         </div>
      )
   )
});

const SortableContainer = sortableContainer(({ children }) => {
   return <>{children}</>;
});

function UploadImg({
   paths,
   uploadStoryImgs,
   deleteImg,
   description,
   isCompliance,
   onSortPhotosEnd,
}) {
   const card = document.querySelector('.card-content');
   if(card && paths){
      let top = 0;
      let Arr = [];
      paths.forEach((photo, index) => {
         if(photo.loading){
            if(index){
               Arr[index] = index * 196 - 80;
            } else {
               Arr[index] = 0;
            }
         } else {
            Arr[index] = null;
         }
      })
      top = Arr.find((item) => {
         return item !== null
      })
      setTimeout(() => {
         if(top && card) {
            card.scrollLeft = top;
         }
      }, 500)
   }

   function onSortEnd({ oldIndex, newIndex }){
      const newData = arrayMoveImmutable(paths, oldIndex, newIndex)
      if(oldIndex !== newIndex){
         onSortPhotosEnd(newData, oldIndex, newIndex)
      }
   }

   return (
      <div style={ { padding: '20px 16px 0 16px' } }>
         {
            isCompliance ? (
               <>
                  {
                     paths[0].loading ? (
                        <div
                           style={ {  height: '230px' } }
                           className={ cx({
                              'mb-4 select-none flex items-center justify-center': true,
                           }) }
                        >
                           <div
                              style={ { width: '180px' } }
                              className='h-full flex items-center justify-center bg-placeholder border border-divider rounded-lg'>
                              <CircleLoader color='major-dark' />
                           </div>
                        </div>
                     ) : (
                        <div
                           style={ {  height: '230px' } }
                           className={ cx({
                              'mb-4 select-none flex items-center justify-center': true,
                           }) }
                        >
                           <div
                              style={ { width: '180px'  } }
                              className='relative  h-full '
                           >
                              <img src={ paths[0].src } className='h-full w-full rounded-lg object-cover object-center' alt='avatar' />
                              <div
                                 className='absolute rounded-t-lg w-full top-0 left-0 flex flex-col pl-2 pr-6 pt-2 z-15'
                              >
                                 {
                                    !!description && (
                                       <h6 className='text-xl text-major-dark font-bold leading-tight mb-2 select-none threeLine'>{ description }</h6>
                                    )
                                 }
                              </div>
                           </div>
                        </div>
                     )
                  }

               </>
            ) : (
               <>
                  <div className='z-10 mb-4 flex justify-center select-none cursor-pointer rounded-lg items-center text-center text-action w-28 h-7'>
                     <label
                        htmlFor='multiplStory'
                     >
                        <div
                           className='cursor-pointer flex items-center justify-center'>
                           <Icon
                              name='add'
                              size='xl'
                              color='action'
                           />
                           <span className='leading-tight font-medium ml-2 select-none cursor-pointer'>Add photo</span>
                        </div>
                     </label>
                     <input
                        id='multiplStory'
                        type='file'
                        accept='image/png,image/jpeg, image/webp'
                        multiple
                        className='opacity-0 absolute z-10 w-0 cursor-pointer'
                        onChange={ (e) => {
                           uploadStoryImgs(e)
                        } }
                     />
                  </div>
                  <div className='overflow-x-auto w-full flex flex-wrap card-content'>
                     <SortableContainer
                        helperClass='sortable-helper'
                        axis='xy'
                        useDragHandle
                        onSortEnd={ onSortEnd }
                     >
                        <div className='relative flex images-card'>
                           {
                              paths.map((value, index) => {
                                 return (
                                    <SortableItem
                                       useDragHandle
                                       onSortEnd={ onSortEnd }
                                       shouldUseDragHandel={ true }
                                       key={ `item-${ index }` }
                                       value={ value }
                                       index={ index }
                                       paths={ paths }
                                       description={ description }
                                       deleteImg={ deleteImg }
                                    />
                                 );
                              })
                           }
                        </div>
                     </SortableContainer>
                  </div>
               </>
            )
         }
      </div>
   );
}
UploadImg.defaultProps = {
   isCompliance: false,
}
UploadImg.propTypes = {
   paths: PropTypes.array,
   uploadStoryImgs: PropTypes.func,
   deleteImg: PropTypes.func,
   description: PropTypes.string,
   isCompliance: PropTypes.bool,
   onSortPhotosEnd: PropTypes.func,
};

export default React.memo(UploadImg);
